import {ActionType} from "../../model/actionTypes";
import { PracticeList } from "../../model/practice";
import {removeNullProperties} from "../../utils/common";
import {errorHandler} from "./auth";

export const fetchPractices = (callBackFunc:Function,brand:string) => async (dispatch: Function, getState: Function, api: any) => {
	try {
		let uri="practicesInfo/getPracticeList"
		uri+=brand?"?brand="+brand:"";
		const response:PracticeList[] = await api.get(uri);
		let orthPracticeNames: any = {};
		let practiceMap: any = {};
		let orthoDublicatePractice : any = [];
		if (response) {
            response.forEach((item: any) => {
				if(item.orthoLocation)
                	orthPracticeNames[item.orthoLocation.toLowerCase()] = item;
            });
			response.forEach((item: any) => {
                practiceMap[item.practice.toLowerCase()] = item;
            })
			orthoDublicatePractice = response.filter(item => item.ortho ===1)

        }		
		dispatch({ type: ActionType.FETCH_PRACTICES_DB,payload: { practiceList: removeNullProperties(orthPracticeNames),practiceNamesMap:removeNullProperties(practiceMap) }});
		const obj = callBackFunc(response);
		dispatch({ type: ActionType.FETCH_PRACTICES, payload: obj});
		let orthoObj = []
		if(orthoDublicatePractice){
			 orthoObj  = refineOrthoPracticeArray(orthoDublicatePractice);
		}
		return Array.from([...obj,...orthoObj]).sort((a, b) => (a.text > b.text ? 1 : -1));
	} catch (err) {
	}
};


export const fetchPractice = (params: string) => async (dispatch: Function, getState: Function, api: any) => {
	try {
		const response:PracticeList = await api.get(`practicesInfo/getPractice/${params}`);
		dispatch({ type: ActionType.FETCH_PRACTICE, payload: response});
		dispatch({ type: ActionType.FETCH_PRACTICES_DB, payload: response});
		dispatch({ type: ActionType.INCREMENT, payload: 1});
		return response;
	} catch (err) {
		dispatch({ type: ActionType.INCREMENT, payload: 1});
		return dispatch({ type: ActionType.FETCH_PRACTICE, payload: { practice: {} } });		
	}
};

export const getPractices = (params = {} as any) => async (dispatch: Function, getState: Function, api: any) => {
	try {
		dispatch({type: ActionType.LOADER, payload: true});
		const query = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
		const response = api.get(`practicesInfo/getPractice?${query}`);
		dispatch({type: ActionType.LOADER, payload: false});
		return response;
	} catch (err) {
		dispatch({type: ActionType.LOADER, payload: false});
		return [];
	}
};

const refineOrthoPracticeArray = (response: any) => {
	let practiceOptions:any = [];
	if (response) {
		response.forEach((item: any) => {
			practiceOptions.push({text:`${item.practice} Ortho` , value: `${item.practice} Ortho`, key: item.id.toString()+"1"});
		})
	}
	return practiceOptions;
};

export const getAllPractices = () => async (dispatch: Function, getState: Function, api: any) => {
	try {
		const response = await api.get(`practicesInfo/getOdPractices`);
		dispatch({type: ActionType.FETCH_ALL_PRACTICES, payload: {allPracticeList : response} });
		dispatch({type: ActionType.LOADER, payload: false});
		return response;
	} catch (error) {
		dispatch({type: ActionType.LOADER, payload: false});
		dispatch(errorHandler(error))
	}
}


export const fetchPracticeList = (data: any) => async (dispatch: Function, getState: Function, api: any) => {
	dispatch({type: ActionType.LOADER, payload: true});
	try {
		const response = await api.get(`broken/allPractices`);
		dispatch({type: ActionType.LOADER, payload: false});
		return response;
	} catch (err) {
		dispatch({type: ActionType.LOADER, payload: false});
		dispatch(errorHandler(err))
		return [];
	}
}
